import { BehaviorSubject, Subject } from 'rxjs';
import * as i0 from "@angular/core";
var DailyLogsService = /** @class */ (function () {
    function DailyLogsService() {
        this.overviewSummaries = new BehaviorSubject({
            reported: 0,
            recorded: 0,
            totalHours: 0
        });
        this.shouldReturn = new Subject();
        this.changeTab = new Subject();
        this.submissionError = new Subject();
    }
    DailyLogsService.prototype.setOverviewSummaries = function (summary) {
        this.overviewSummaries.next(summary);
    };
    DailyLogsService.prototype.shouldReturnToDailyLog = function () {
        this.shouldReturn.next(true);
    };
    DailyLogsService.prototype.notifyTabChange = function (tabName, params) {
        if (params === void 0) { params = {}; }
        this.changeTab.next({ slug: tabName, params: params });
    };
    DailyLogsService.ngInjectableDef = i0.defineInjectable({ factory: function DailyLogsService_Factory() { return new DailyLogsService(); }, token: DailyLogsService, providedIn: "root" });
    return DailyLogsService;
}());
export { DailyLogsService };
